import React, { useEffect, useRef, useState } from 'react';
import { Button, Dropdown, Modal, message, Space } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import '../style.less';
import logo from '../../../assets/img/home_logo.png';
import {
    beginAnswerApi,
    getAuthDictionaryInfo,
    getMemAllInfoByMemCard,
    getUserInfoApi,
    reportCheckApi,
    surveyInfoApi,
    templateDetailApi,
    updateAuthTime,
} from '../api';
import { getCookie, getQueryString, loadScript } from '../../../utils/utils';
import config from '../../../config';
import shareLogo from '../../../assets/img/share_logo.png';
import redoLogo from '@/assets/img/redo.png';
import rightLogo from '@/assets/img/right.png';
import fillLogo from '@/assets/img/fill.png';
import Cookies from 'js-cookie';
import {
    buildIdentityNameMap,
    getUserAuthDisplayInfo,
    resolveOssUrl,
    shouldShowAuthInfoConfirm,
} from '../utils/authInfo';
import type { UserAuthDisplayInfo } from '../utils/authInfo';

interface TitleStyleParams {
    color: string;
    rgb: string;
}

// 判断ios/安卓
const browser = {
    versions: (function () {
        let u = navigator.userAgent;
        return {
            //移动终端浏览器版本信息
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        };
    })(),
    language: ((navigator as any).browserLanguage || navigator.language).toLowerCase(),
};

// 是否为app内打开
const isApp = getCookie('platform') === 'cn-healthcare';

const SurveyStart: React.FC = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [title, setTitle] = useState('');
    const [isNeedLogin, setNeedLogin] = useState<boolean>();
    const isStatus = useRef(null);
    const [h5Cover, setH5Cover] = useState(false);
    const [webCover, setWebCover] = useState(false);
    const [isShowBegin, setIsShowBegin] = useState(false);

    // 封面展示配置项
    const [surveyData, setSurveyData] = useState<any>(null);
    const [titleStyle, setTitleStyle] = useState<TitleStyleParams>();

    // 查看报告
    const [reportInfo, setReportInfo] = useState<any>(null);

    const [showCover, setShowCover] = useState(false);
    const [showH5Cover, setShowH5Cover] = useState(false);

    // 认证信息确认弹窗（个人认证审核超 1 年）
    const [showAuthInfoModal, setShowAuthInfoModal] = useState(false);
    const [authDisplayInfo, setAuthDisplayInfo] = useState<UserAuthDisplayInfo | null>(null);
    const [confirmAuthLoading, setConfirmAuthLoading] = useState(false);
    const [showImagePreview, setShowImagePreview] = useState(false);
    const [previewImageUrl, setPreviewImageUrl] = useState('');

    const items = [
        {
            key: '1',
            label: (
                <a target="_blank" onClick={() => logout()}>退出登录</a>
            ),
        },
    ];

    const isWeiXin = () => {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('micromessenger') !== -1;
    };

    // 退出登录
    const logout = () => {
        const options = { domain: '.cn-healthcare.com' };

        Cookies.remove('memToken', options);
        Cookies.remove('memNickname', options);
        Cookies.remove('memHeadImg', options);
        Cookies.remove('authentication_member_card', options);
        Cookies.remove('memAuthStatus', options);
        Cookies.remove('vipLevel', options);

        window.location.reload();
    };

    const continueAnswer = (type: number) => {
        if (type === 1) {
            navigate(`/s/${params.id}/answer`);
        } else {
            localStorage.removeItem('formData');
            localStorage.removeItem('initFormData');
            localStorage.removeItem('surveyId');
            localStorage.removeItem('surveyList');
            localStorage.removeItem('surveyListTime');

            navigate(`/s/${params.id}/answer`);
        }
    };

    const initBegin = (res: any) => {
        localStorage.setItem('answersheetId', res?.data?.id);
        navigate(`/s/${params.id}/answer`);
    };

    // 开始作答
    const beginAnswer = async () => {
        if (isStatus && isStatus.current === 0) {
            return message.error('问卷未发布，无法访问');
        }
        const channelId = getQueryString('channelId') || getQueryString('chid');
        const res: any = await beginAnswerApi({
            surveyId: params?.id,
            channelId: channelId || undefined,
            projectId: getQueryString('projectId') || '',
            resource: getQueryString('projectId') ? 'JXY' : undefined,
        });
        if (res && res.status_code === 200) {
            initBegin(res);
        }
    };

    // 开始作答（进入页面立即请求接口）
    const intoBeginAnswer = async () => {
        if (isStatus && isStatus.current === 0) {
            return message.error('问卷未发布，无法访问');
        }
        const channelId = getQueryString('channelId') || getQueryString('chid');
        const res: any = await beginAnswerApi({
            surveyId: params?.id,
            channelId: channelId || undefined,
            projectId: getQueryString('projectId') || '',
            resource: getQueryString('projectId') ? 'JXY' : undefined,
        });
    };

    // 获取问卷基本信息
    const getSurveyInfo = async () => {
        const res: any = await surveyInfoApi({ id: params?.id });
        if (res.status_code === 200) {
            document.title = res.data.name || '医调研';
            localStorage.setItem('sessionId', res?.data?.sessionId);
            setSurveyData(res.data);
            setTitle(res.data.name);
            setNeedLogin(res.data.isNeedLogin);
            isStatus.current = res.data.status;
            const survey: any = document.getElementsByClassName('survey')[0];

            if (window.innerWidth > 750) {
                if (res.data.webCover) {
                    survey.style.backgroundImage = `url(${res.data.webCover})`;
                } else {
                    setShowCover(true);
                }
            } else {
                if (res.data.h5Cover) {
                    survey.style.backgroundImage = `url(${res.data.h5Cover})`;
                } else {
                    setShowH5Cover(true);
                }
            }

            if (res.data?.status === 2 && !getQueryString('type')) {
                message.error('该问卷已下架，感谢您的参与。');
                navigate(`/s/error?type=${2}`, { replace: true });
                return;
            }
            setIsShowBegin(true);

            // 标题配置样式
            if (res.data?.titleColor) {
                const titleColor: any = JSON.parse(res.data.titleColor);
                const params = {
                    color: titleColor.hex || '#FFFFFF',
                    rgb: titleColor?.color?.a || 1,
                };
                setTitleStyle(params);
            }

            initWexin(res.data);

            // 要求认证时，检查个人认证是否超 1 年需确认（模板预览不走此逻辑）
            checkAuthInfoConfirm(res.data);

            // 进入页面立即调取开始作答
            intoBeginAnswer();

            // 问卷有变动 || 缓存数据不等于当前问卷，清除缓存
            const localCacheTime = localStorage.getItem('surveyListTime') ? Number(localStorage.getItem('surveyListTime')) : 0;
            const equalSurveyId = localStorage.getItem('surveyId') !== params.id;
            const cacheTime = res.data.cacheDate ? new Date(res.data.cacheDate).getTime() : 0;
            if (cacheTime > localCacheTime || equalSurveyId) {
                localStorage.removeItem('formData');
                localStorage.removeItem('initFormData');
                localStorage.removeItem('surveyId');
                localStorage.removeItem('surveyList');
                localStorage.removeItem('surveyListTime');
            }

            // QT 埋点
            // 页面浏览：医调研-查看问卷
            const checkInterval = setInterval(() => {
                if ((window as any)?.aplus_queue?.push) {
                    const cusp: {
                        page_name: string;
                        survey_id: number;
                        survey_title: string;
                        chid?: number;
                        empid?: number;
                        source?: string;
                    } = {
                        page_name: 'survey_view_page',
                        survey_id: res.data.id,
                        survey_title: res.data.name,
                    };
                    const channelId = getQueryString('channelId') || getQueryString('chid');
                    if (channelId) {
                        cusp.chid = Number(channelId);
                    }
                    if (getQueryString('empid')) {
                        cusp.empid = Number(getQueryString('empid'));
                    }
                    if (getQueryString('source')) {
                        cusp.source = getQueryString('source') || '';
                    }
                    (window as any).aplus_queue.push({
                        action: 'aplus.sendPV',
                        arguments: [{ is_auto: false }, cusp],
                    });
                    clearInterval(checkInterval);
                }
            }, 100);
            // 设置超时，避免无限等待
            setTimeout(() => {
                clearInterval(checkInterval);
            }, 5000);
        }
    };

    // 获取模板基本信息
    const getTemplateInfo = async () => {
        const res: any = await templateDetailApi({ id: params?.id });
        if (res.status_code === 200) {
            setSurveyData(res.data);
            setTitle(res.data.name);
            setNeedLogin(res.data.isNeedLogin);
            const survey: any = document.getElementsByClassName('survey')[0];

            if (window.innerWidth > 750) {
                if (res.data.webCover) {
                    survey.style.backgroundImage = `url(${res.data.webCover})`;
                } else {
                    setShowCover(true);
                }
            } else {
                if (res.data.h5Cover) {
                    survey.style.backgroundImage = `url(${res.data.h5Cover})`;
                } else {
                    alert('true');
                    setShowH5Cover(true);
                }
            }

            setIsShowBegin(true);

            // 标题配置样式
            if (res.data?.titleColor) {
                const titleColor: any = JSON.parse(res.data.titleColor);
                const params = {
                    color: titleColor.hex || '#FFFFFF',
                    rgb: titleColor?.color?.a || 1,
                };
                setTitleStyle(params);
            }
        }
    };

    // 跳转登录
    const login = () => {
        // App内跳转
        if (getCookie('platform') === 'cn-healthcare') {
            window.location.href = 'native://login?sourceId=101001';
        } else {
            window.location.href = `${config.UCENTER_URL}/rlogin/logout?redirectUrl=${encodeURIComponent(window.location.href)}`;
        }
    };

    // 初始化微信分享js
    const initWexin = async (wexin: any) => {
        await Promise.all([loadScript('https://res.wx.qq.com/open/js/jweixin-1.6.0.js'), loadScript('https://files.cn-healthcare.com/lib/jquery/dist/jquery.min.js')]);

        (await loadScript('https://files.cn-healthcare.com/skin/jkj5/wap/js/wxshare.js')) as HTMLScriptElement;

        setPageMeta(wexin);
    };

    // 文件路径 - 前缀
    const getFileUrl = (url?: string) => {
        if (!url || url?.includes('static')) {
            return `${window.location.origin}${shareLogo}`;
        }
        if (url?.includes('https')) {
            return url;
        }
        if (url && !url.includes('https')) {
            return `${config.OSS_URL_PREFIX}/${url}`;
        }
        return '';
    };

    // 设置微信分享
    const setPageMeta = (wexin: any) => {
        const oMeta = document.getElementsByTagName('head')[0];
        ['sharetitle', 'sharepic', 'sharedesc', 'shareurl'].forEach(name => {
            const meta = document.createElement('meta');
            meta.name = name;
            if (name === 'sharetitle') {
                meta.content = wexin.shareTitle || wexin.name;
            }
            if (name === 'sharepic') {
                meta.content = getFileUrl(wexin.shareLogoUrl);
            }
            if (name === 'sharedesc') {
                meta.content = wexin.shareDirections || '希望大家能够踊跃参加';
            }
            if (name === 'shareurl') {
                const channel_id = getQueryString('channelId') || getQueryString('chid') || localStorage.getItem('channelId');
                if (channel_id) {
                    meta.content = `${window.location.origin}/s/${params.id}?channelId=${channel_id}`;
                } else {
                    meta.content = `${window.location.origin}/s/${params.id}`;
                }
            }
            oMeta.appendChild(meta);

            // App内打开
            if (isApp) {
                const channel_id = getQueryString('channelId') || getQueryString('chid') || localStorage.getItem('channelId');
                let showUrl = '';
                if (channel_id) {
                    showUrl = `${window.location.origin}/s/${params.id}?channelId=${channel_id}`;
                } else {
                    showUrl = `${window.location.origin}/s/${params.id}`;
                }
                const title = wexin.shareTitle || wexin.name;
                const direction = wexin.shareDirections || '希望大家能够踊跃参加';

                // ios
                if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
                    const postInfo = {
                        title: '分享',
                        url: `appfunc://shareView?title=${encodeURIComponent(title)}&content=${encodeURIComponent(direction)}&shareurl=${showUrl}&shareimage=${getFileUrl(wexin.shareLogoUrl)}`,
                    };
                    (window as any).webkit.messageHandlers.navigationRightItem.postMessage(JSON.stringify(postInfo));

                    // 安卓
                } else if (browser.versions.android) {
                    (window as any).imagelistner.showTitle(title);
                    (window as any).imagelistner.showUrl(showUrl);
                    (window as any).imagelistner.showDes(direction);
                    (window as any).imagelistner.showPic(getFileUrl(wexin.shareLogoUrl));
                }
            }

            // 微信小程序内
            if (typeof (window as any).wx !== 'undefined' && (window as any).wx.miniProgram) {
                const channelId = getQueryString('channelId') || getQueryString('chid') || localStorage.getItem('channelId');
                let showUrl = '';
                if (channelId) {
                    showUrl = `${window.location.origin}/s/${params.id}?channelId=${channelId}`;
                } else {
                    showUrl = `${window.location.origin}/s/${params.id}`;
                }
                let title = wexin.shareTitle || wexin.name;
                (window as any).wx.miniProgram.postMessage({
                    data: {
                        shareTitle: title,
                        shareImage: getFileUrl(wexin.shareLogoUrl),
                        shareUrl: showUrl,
                    },
                });
            }
        });
    };

    // 通过 ucenter 接口获取用户信息（含认证）
    const getMemInfo = async (resData: any) => {
        const memCard = Cookies.get('authentication_member_card') || '';
        if (!memCard) {
            return null;
        }
        const res: any = await getUserInfoApi({ memCard });
        if (res) {
            const memInfoData = res.data || null;
            const authTypePermitted = memInfoData.memType === 1 && (memInfoData.memIsyijiehui === 1 || memInfoData.memIsyijiehui === 3) && memInfoData?.qitaMap?.memIdentity === 'A01';
            if (authTypePermitted) {
                initBegin(resData);
            } else {
                navigate(`/s/error?type=${4}`, { replace: true });
            }
        }
    };

    // 问卷要求认证时，个人认证已通过且审核超 1 年则弹确认窗
    const checkAuthInfoConfirm = async (survey: any) => {
        if (!survey?.isNeedAuth && !survey?.isNeedAuthInfo) {
            return;
        }
        const memCard = Cookies.get('authentication_member_card') || '';
        if (!memCard) {
            return;
        }
        try {
            const [memInfo, dictRes]: any[] = await Promise.all([
                getMemAllInfoByMemCard({ memCard }),
                getAuthDictionaryInfo().catch((error: any) => {
                    console.error('获取认证身份字典失败:', error);
                    return null;
                }),
            ]);
            if (!memInfo) {
                return;
            }
            if (shouldShowAuthInfoConfirm(memInfo)) {
                const identityNameMap = buildIdentityNameMap(dictRes?.data?.options || dictRes?.options);
                setAuthDisplayInfo(getUserAuthDisplayInfo(memInfo, identityNameMap));
                setShowAuthInfoModal(true);
            }
        } catch (error) {
            console.error('获取用户认证信息失败:', error);
        }
    };

    // 确认认证信息：刷新认证时间
    const handleConfirmAuthInfo = async () => {
        const memCard = Cookies.get('authentication_member_card') || '';
        if (!memCard) {
            message.error('未获取到用户信息，请重新登录');
            return;
        }
        setConfirmAuthLoading(true);
        try {
            await updateAuthTime({ memCard });
            message.success('认证信息确认成功');
            setShowAuthInfoModal(false);
        } catch (error) {
            console.error('更新认证时间失败:', error);
            message.error('信息确认失败，请稍后重试');
        } finally {
            setConfirmAuthLoading(false);
        }
    };

    // 跳转用户中心修改认证信息
    const gotoAuthPage = () => {
        window.location.href = `${config.USERCENTER_PREFIX}/m/certificate?backUrl=${encodeURIComponent(window.location.href)}&edit=1`;
    };

    // 预览认证资料图片（健康界文件域 FILE_URL_PREFIX，对齐 JKJ_OSS_URL_PREFIX）
    const handlePreviewAuthIdentity = () => {
        if (!authDisplayInfo?.identityPath) {
            return;
        }
        const fullUrl = resolveOssUrl(authDisplayInfo.identityPath, config.FILE_URL_PREFIX || '');
        if (!fullUrl) {
            return;
        }
        setPreviewImageUrl(fullUrl);
        setShowImagePreview(true);
    };

    // 查看报告
    const getSurveyReport = async () => {
        const res: any = await reportCheckApi({ surveyId: params?.id });
        if (res.status_code === 200 && res.data) {
            if (res.data.isJump) {
                navigate(`/s/error?type=${2}`, { replace: true });
            } else {
                setReportInfo(res.data);
                getSurveyInfo();
            }
        }
    };

    const viewReport = async (info: any) => {
        navigate(`/s/${params.id}/report`, { state: { info } });
    };

    const init = () => {
        if (getQueryString('empid')) {
            localStorage.setItem('empid', getQueryString('empid') || '');
        }

        // 渠道id（埋点与业务共用，兼容 chid）
        if (localStorage.getItem('channelId') || localStorage.getItem('chid')) {
            localStorage.removeItem('channelId');
            localStorage.removeItem('chid');
        }
        const channel_id = getQueryString('channelId') || getQueryString('chid');
        if (channel_id) {
            localStorage.setItem('channelId', channel_id);
        }

        // 兼容后台模板封面预览
        if (getQueryString('template') === '1') {
            getTemplateInfo();
        } else {
            getSurveyReport();
        }
    };

    useEffect(() => {
        init();
    }, []);

    // 处理标题字体大小 - pc、移动端
    const dealTitleSize = (titleFont?: number) => {
        if (window.innerWidth > 750) {
            if (titleFont) {
                return `${titleFont}px`;
            } else {
                return '84px';
            }
        } else {
            if (titleFont) {
                return `${titleFont / 280}rem`;
            } else {
                return '0.25rem';
            }
        }
    };

    return (
        <div className={`survey ${showCover && 'survey-default-cover'} ${showH5Cover ? 'survey-default-h5cover' : ''}`}>
            {!!surveyData?.isDisplayLogo && (
                <div className="survey-logo">
                    <img src={logo} alt="" />
                </div>
            )}

            {!isWeiXin() && getCookie('memToken') && getCookie('authentication_member_card') && !isApp && (
                <div className="survey-logout">
                    <Dropdown menu={{ items }}>
                        <Space>
                            <i className="bi bi-list"></i>
                        </Space>
                    </Dropdown>
                </div>
            )}

            <div className="title">{!!surveyData?.isDisplayTitle && <span style={{ color: titleStyle?.color, opacity: titleStyle?.rgb }} dangerouslySetInnerHTML={{ __html: title }}></span>}</div>

            {isShowBegin && (
                <div className={`survey-btns ${!surveyData?.isDisplayTitle ? 'survey-btns-default' : null}`}>
                    {reportInfo?.reportEnabled ? (
                        <Button onClick={() => viewReport(reportInfo)} className="beginFill">
                            查看报告
                        </Button>
                    ) : !localStorage.getItem('formData') || (localStorage.getItem('formData') && (!localStorage.getItem('surveyId') || localStorage.getItem('surveyId') !== params.id)) ? (
                        <>
                            {isNeedLogin && (!getCookie('memToken') || !getCookie('authentication_member_card')) ? (
                                <Button onClick={login} className="beginFill">
                                    登录/注册
                                </Button>
                            ) : (
                                <Button onClick={beginAnswer} className="beginFill">
                                    开始填写
                                    <img src={fillLogo} alt="" />
                                </Button>
                            )}
                        </>
                    ) : (
                        <>
                            <Button onClick={() => continueAnswer(1)} className="continueFill">
                                继续填写
                                <img src={rightLogo} alt="" />
                            </Button>
                            <Button type="primary" onClick={() => continueAnswer(2)} className="reFill">
                                重新填写
                                <img src={redoLogo} alt="" />
                            </Button>
                        </>
                    )}
                </div>
            )}

            <Modal
                title={null}
                visible={showAuthInfoModal}
                footer={null}
                centered
                closable={false}
                maskClosable={false}
                keyboard={false}
                className="auth-info-modal"
                width={480}
                zIndex={1100}
            >
                <div className="auth-info-content" role="dialog" aria-labelledby="auth-info-title" aria-describedby="auth-info-desc">
                    <div className="auth-info-header">
                        <h2 id="auth-info-title" className="auth-info-title">认证信息确认</h2>
                        <p id="auth-info-desc" className="auth-info-desc">您的认证信息已超过 1 年，请确认是否仍准确有效，确认或更新后即可继续享受完整服务权益。</p>
                    </div>
                    {authDisplayInfo && (
                        <div className="auth-info-detail">
                            <div className="auth-info-detail-title">当前认证信息</div>
                            <dl className="auth-info-list">
                                <div className="auth-info-row">
                                    <dt className="auth-info-label">认证身份</dt>
                                    <dd className="auth-info-value">{authDisplayInfo.identityName || '-'}</dd>
                                </div>
                                <div className="auth-info-row">
                                    <dt className="auth-info-label">姓名</dt>
                                    <dd className="auth-info-value">{authDisplayInfo.name || '-'}</dd>
                                </div>
                                <div className="auth-info-row">
                                    <dt className="auth-info-label">单位</dt>
                                    <dd className="auth-info-value">{authDisplayInfo.hospital || '-'}</dd>
                                </div>
                                {authDisplayInfo.identityCode === 'A01' && (
                                    <div className="auth-info-row">
                                        <dt className="auth-info-label">科室</dt>
                                        <dd className="auth-info-value">{authDisplayInfo.office || '-'}</dd>
                                    </div>
                                )}
                                <div className="auth-info-row">
                                    <dt className="auth-info-label">职务</dt>
                                    <dd className="auth-info-value">{authDisplayInfo.job || '-'}</dd>
                                </div>
                                <div className="auth-info-row">
                                    <dt className="auth-info-label">认证资料</dt>
                                    <dd className="auth-info-value">
                                        {authDisplayInfo.identityPath ? (
                                            <button type="button" className="auth-info-link" onClick={handlePreviewAuthIdentity}>
                                                点击查看
                                            </button>
                                        ) : (
                                            '-'
                                        )}
                                    </dd>
                                </div>
                                <div className="auth-info-row auth-info-row-highlight">
                                    <dt className="auth-info-label">认证时间</dt>
                                    <dd className="auth-info-value">{authDisplayInfo.authTime || '-'}</dd>
                                </div>
                            </dl>
                        </div>
                    )}
                    
                    <div className="auth-info-actions">
                        <Button className="modify-btn" disabled={confirmAuthLoading} onClick={gotoAuthPage}>
                            修改信息
                        </Button>
                        <Button
                            type="primary"
                            className="confirm-info-btn"
                            loading={confirmAuthLoading}
                            disabled={confirmAuthLoading}
                            onClick={handleConfirmAuthInfo}
                        >
                            确认信息
                        </Button>
                    </div>
                </div>
            </Modal>

            <Modal
                title="认证材料"
                visible={showImagePreview}
                footer={null}
                centered
                closable
                maskClosable
                className="auth-image-preview-modal"
                onCancel={() => setShowImagePreview(false)}
                width={560}
                zIndex={1200}
            >
                <div className="auth-image-preview-content">
                    {previewImageUrl ? <img src={previewImageUrl} alt="认证材料" /> : null}
                </div>
            </Modal>
        </div>
    );
};

export default SurveyStart;
